<div class="container mx-auto px-4 py-6" *transloco="let t">
  <div class="p-6 w-full max-w-7xl mx-auto bg-white shadow-md rounded-lg">
    <h2 class="text-2xl font-bold mb-4 text-gray-700">{{ isEditMode ? t('users.form.editUser') : t('users.form.createUser') }}</h2>

    <!-- Email -->
    <div class="mb-6">
      <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.col.email') }} {{ !isEditMode ? '*' : '' }}
      </label>
      <input
        type="email"
        id="email"
        [(ngModel)]="email"
        #emailInput="ngModel"
        [required]="!isEditMode"
        class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        [placeholder]="t('users.form.emailPlaceholder')">

      <div *ngIf="formSubmitted && emailInput.invalid && !isEditMode" class="text-red-600 text-sm mt-1">
        {{ t('users.form.emailRequired') }}
      </div>
      <div *ngIf="formSubmitted && email && !isValidEmail(email)" class="text-red-600 text-sm mt-1">
        {{ t('users.form.emailInvalid') }}
      </div>
    </div>

    <!-- Password -->
    <div class="mb-6">
      <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.form.password') }} {{ !isEditMode ? '*' : '' }}
      </label>
      <input
        type="password"
        id="password"
        [(ngModel)]="password"
        #passwordInput="ngModel"
        [required]="!isEditMode"
        [minlength]="6"
        class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        [placeholder]="t('users.form.passwordPlaceholder')">

      <div *ngIf="formSubmitted && passwordInput.invalid && !isEditMode" class="text-red-600 text-sm mt-1">
        {{ t('users.form.passwordRequired') }}
      </div>
      <div *ngIf="formSubmitted && password && password.length < 6" class="text-red-600 text-sm mt-1">
        {{ t('users.form.passwordMin') }}
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="mb-6">
      <label for="confirmPassword" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.form.confirmPassword') }} {{ !isEditMode ? '*' : (password ? '*' : '') }}
      </label>
      <input
        type="password"
        id="confirmPassword"
        [(ngModel)]="confirmPassword"
        #confirmPasswordInput="ngModel"
        [required]="!isEditMode || (isEditMode && password)"
        class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        [placeholder]="t('users.form.confirmPasswordPlaceholder')">

      <div *ngIf="formSubmitted && confirmPasswordInput.invalid && (!isEditMode || (isEditMode && password))" class="text-red-600 text-sm mt-1">
        {{ t('users.form.confirmRequired') }}
      </div>
      <div *ngIf="formSubmitted && password && confirmPassword && password !== confirmPassword" class="text-red-600 text-sm mt-1">
        {{ t('users.form.passwordsMismatch') }}
      </div>
    </div>

    <!-- Perfis -->
    <div class="mb-6">
      <label for="profiles" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.col.profiles') }}
      </label>
      <ng-select
        id="profiles"
        [(ngModel)]="selectedProfileIds"
        (change)="onProfileChange($event)"
        [items]="profiles"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [clearable]="true"
        [searchable]="true"
        [placeholder]="t('users.form.selectProfiles')"
        class="w-full">
      </ng-select>
      <p class="text-gray-500 text-xs mt-1">{{ t('users.form.profilesHint') }}</p>
    </div>

    <!-- Botões de Ação -->
    <div class="mt-6 flex justify-end space-x-4">
      <button
        (click)="save()"
        class="w-32 h-10 bg-green-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
        {{ t('common.save') }}
      </button>
      <button
        (click)="cancelar()"
        class="w-32 h-10 bg-gray-600 text-white rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
        {{ t('common.cancel') }}
      </button>
    </div>
  </div>
</div>
